module.exports = __webpack_public_path__ + "img/cloth_g3_item-06.7949713e.svg";